import { render, staticRenderFns } from "./widget-rate.vue?vue&type=template&id=0db1bfd8&"
import script from "./widget-rate.vue?vue&type=script&lang=js&"
export * from "./widget-rate.vue?vue&type=script&lang=js&"
import style0 from "./widget-rate.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports